<template>
    <div>
        <div class="e-title">用户评分详情</div>
        <el-descriptions :column="1">
            <el-descriptions-item label="用户评分">
                <el-rate v-model="data.rating" disabled show-score text-color="#ff9900" score-template="{value}">
                </el-rate>
            </el-descriptions-item>
            <el-descriptions-item label="反馈内容">{{ data.comment }}</el-descriptions-item>
            <el-descriptions-item label="邮箱地址">{{ data.email }}</el-descriptions-item>
            <el-descriptions-item label="反馈时间">{{ formatDate(data.createTime) }}</el-descriptions-item>
        </el-descriptions>
        <el-button size="mini" type="primary" @click="$router.back()">返回</el-button>
    </div>
</template>

<script>
import { detail } from "@/api/feedback";
import dayjs from "dayjs";
export default {
    data() {
        return {
            data: {},
        }
    },
    mounted() {
        const id = this.$route.query.id;
        detail(id).then(({ code, data, message }) => {
            if (code == 200) {
                this.data = data;
            } else {
                this.$message.error(message);
            }
        });
    },
    methods: {
        formatDate(date) {
            return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
        },
    }
}
</script>

<style></style>